var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:{ hidden: _vm.$vuetify.breakpoint.lgAndUp },attrs:{"color":"primary","elevation":"0","small":"","fab":"","ripple":false},on:{"click":function($event){return _vm.$emit('click')}}},[_c('inline-svg',{attrs:{"src":require('@/modules/Layout/assets/icons/menu.svg'),"width":"23"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }